<template lang="pug">
    div.instructor

        // Stop Streaming Link button
        v-tooltip(
            color="transparent"
            content-class="instructorTooltip"
            top
        )
            template(v-slot:activator="{ on }")
                div.instructorBadge(v-on="on")

                    // Instructor Avatar
                    div.instructorImage(v-if="avatar")
                        img(:src="avatar")

                    // Instructor Avatar stub
                    div.instructorImageStub(v-else) {{ fullName | fullNameInitials}}

                    // Instructor Name
                    div.instructorFullName
                        span {{ `By ` }}
                        span {{  fullName| formattedFullName }}

</template>

<script>
    import VueTypes from 'vue-types';
    import formattedFullName from '~filters/FormattedFullName';
    import fullNameInitials from '~filters/FullNameInitials';

    export default {
        filters: {
            formattedFullName,
            fullNameInitials
        },
        props: {
            fullName: VueTypes.string.def(undefined),
            avatar: VueTypes.string.def(undefined)
        }
    };
</script>

<style lang="stylus" scoped>
    @import '../../../../../assets/style/_variables.styl'

    .instructorTooltip
        background: $theme.white !important
        border-radius: 10px
        padding: 15px

    .instructorHover
        background: $theme.white !important
        color: $theme.black
        width: 340px
        opacity: 1

    .instructorHoverName
        font-size: 18px
        font-weight: 700

    .instructorHoverPosition
        color: $theme.primary
        font-size: 14px
        opacity: 0.8
        margin-bottom: 10px

    .instructorHoverContent
        display: flex

    .instructorHoverImage
        flex: 1 1 50%

        img
            min-width: 160px
            border-radius: 50%

    .instructorHoverInformation
        margin-left: 10px
        flex: 1 1 50%

    .instructor
        display: flex
        align-items: center

    .instructorImage
        margin-right: 10px

    .instructorBadge
        display: flex
        align-items: center

    .instructorImageStub
    .instructorImage img
        width: 42px
        height: 42px
        border-radius: 42px

    .instructorFullName
        font-style: italic;
        font-weight: normal;
        font-size: 12px;

    .instructorImageStub
        margin-right: 10px
        background-color: $theme.white
        opacity: 0.5
        color: $theme.primary
        text-align: center
        font-size: 27px
        line-height: 44px
        font-weight: 700

    .instructorHoverClose
        position: absolute
        top: 4px
        right: 3px

    @media screen and (max-width: 400px)
        .instructorHover
            width: 100%
</style>
